import { render, staticRenderFns } from "./HistoryControls.vue?vue&type=template&id=6aaead0e&scoped=true&"
import script from "./HistoryControls.vue?vue&type=script&lang=js&"
export * from "./HistoryControls.vue?vue&type=script&lang=js&"
import style0 from "./HistoryControls.vue?vue&type=style&index=0&id=6aaead0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaead0e",
  null
  
)

export default component.exports